module.exports = __webpack_public_path__ + "media/images/list_practice/8-01-65d7cf00d8c3dbafd0f3c619b42df7ca.svg";